import React from 'react';
import '../../styles/sections.css';
import '../../styles/overview.css';

const Overview = () => (
  <div className="overview-section">
    <div className="section-header">
      <h2>OVERVIEW</h2>
      <div className="underline"></div>
    </div>
    <div className="overview-content">
      <p>
        CLIMB OR DIE! is an adrenaline-pumping Roblox game that challenges players to reach the top or face elimination. 
        Players navigate through increasingly difficult obstacles, avoid deadly traps, and compete against time and other players 
        in this thrilling climbing adventure.
      </p>
      <p>
        The game features dynamic difficulty scaling, multiple game modes, power-ups, and a comprehensive leaderboard system. 
        Built entirely with Roblox Studio and Lua scripting, it showcases advanced game development techniques and creative 
        gameplay mechanics.
      </p>
    </div>
  </div>
);

export default Overview;
